export enum Display {
	List = "List",
	Table = "Table",
	Kanban = "Kanban",
}

const EXPORT_DISPLAY: Record<Display, Display> = {
	[Display.List]: Display.List,
	[Display.Kanban]: Display.List,
	[Display.Table]: Display.Table,
};

/** Word and PDF have one list renderer and one table renderer; the interactive displays collapse onto those two. */
export const getExportDisplay = (display: Display): Display => EXPORT_DISPLAY[display] ?? Display.List;
